import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/Hyphen.svg'


const _hoisted_1 = { class: "sensors" }
const _hoisted_2 = { class: "sensors__header" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "chooseDate" }
const _hoisted_5 = { class: "date-block" }
const _hoisted_6 = { class: "date-inputs" }
const _hoisted_7 = { class: "input" }
const _hoisted_8 = { class: "input" }
const _hoisted_9 = {
  key: 0,
  class: "date-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Title = _resolveComponent("Title")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_SensorsMain = _resolveComponent("SensorsMain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading || !_ctx.chartLoaded)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_Title, {
      title: _ctx.$t('sensors')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Dropdown, {
          class: "sensors__header-dropdown",
          "selected-option": _ctx.selectedSensors.selectedOption,
          options: _ctx.selectedSensors.options,
          "data-testid": "selectSensors",
          multiple: true,
          onSelectOption: _ctx.selectSensors
        }, null, 8, ["selected-option", "options", "onSelectOption"]),
        _createVNode(_component_Button, {
          class: "checkAllTemperatures-button",
          variant: "filled",
          title: _ctx.$t('checkAllTemperatures'),
          onClick: _ctx.initCheckAllTemperatures
        }, null, 8, ["title", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Calendar, {
                type: "date",
                format: "DD/MM/YYYY",
                value: _ctx.dateRange.startTime,
                name: "startTime",
                onChange: _ctx.changeDate,
                onClosePanel: _ctx.closeTimePanel
              }, null, 8, ["value", "onChange", "onClosePanel"])
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              class: "date-img",
              src: _imports_0,
              alt: "Hyphen"
            }, null, -1)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Calendar, {
                type: "date",
                format: "DD/MM/YYYY",
                value: _ctx.dateRange.endTime,
                name: "endTime",
                onChange: _ctx.changeDate,
                onClosePanel: _ctx.closeTimePanel
              }, null, 8, ["value", "onChange", "onClosePanel"])
            ])
          ]),
          (!_ctx.isDateCorrect)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('errorDate')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_SensorsMain, {
      pharmacy: _ctx.pharmacy,
      "line-chart-key": _ctx.lineChartKey,
      "data-line-chart": _ctx.dataLineChart,
      "alarms-sensor": _ctx.alarmsSensor,
      "is-date-correct": _ctx.isDateCorrect,
      "selected-sensors-data": _ctx.selectedSensorsData,
      "selected-option": _ctx.selectedSensors.selectedOption,
      "temperature-sensor-stamp": _ctx.temperatureSensorStamp
    }, null, 8, ["pharmacy", "line-chart-key", "data-line-chart", "alarms-sensor", "is-date-correct", "selected-sensors-data", "selected-option", "temperature-sensor-stamp"])
  ]))
}